export default {
    moves: 'Gājieni',
    time: 'Laiks',
    score: 'Rezultāts',
    settings: 'Iestatījumi',
    sounds: 'Skaņa',
    autocomplete: 'Automātiski aizpildīt',
    leftHanded: 'Kreilis',
    newDeal: 'Jauna spēle',
    design: 'Dizains',
    easy: 'Viegls',
    medium: 'Vidējs',
    hard: 'Grūts',
    expert: 'Eksperta',
    master: 'Meistara',
    random: 'Nejaušs',
    balanced: 'Līdzsvars',

    rulesKlondikeURL: 'https://solitaires.com/lv/articles/how-to-play-solitaire/',
    cardHighlight: 'Kāršu izcelšana',
    rulesSpiderURL: 'https://solitaires.com/lv/articles/how-to-play-spider-solitaire/',
    rulesFreecellURL: 'https://solitaires.com/lv/articles/how-to-play-freecell-solitaire/',
    autoPlay: 'Automātiskais režīms',
    noMagicNeeded: 'Nav vajadzīga Burvju nūjiņa — turpiniet spēli pats!',
    leaveFeedback: 'Atstājiet atsauksmi',
    feedbackThankYou: 'Pateicamies par tavu atsauksmi!',
    feedbackError: 'Radās kļūda. Jūsu ziņojums netika nosūtīts.',
    thanksSubscribing: 'Paldies, ka abonējāt!',
    rulesPyramidURL: 'https://solitaires.com/lv/articles/how-to-play-pyramid-solitaire/',

    tutorialSkip: 'Izlaist',
    tutorialRestart: 'Sākt no sākuma',

    klondikeTutorialStep1: 'Tavs mērķis ir pārvietot visas kārtis uz pamata kaudzēm, katru mastu sakārtojot augošā secībā no dūža līdz kungam — piemēram, <span style="color: #F11F1F;">A♥, 2♥, 3♥</span> un tā tālāk. Spied uz kārti, lai to pārvietotu!',
    klondikeTutorialStep2: 'Lieliski! Turpini veidot secības pamata kaudzēs.',
    klondikeTutorialStep3: 'Labi padarīts! Tu vari pārvietot kārtis starp kolonnām — vienkārši noliec kārti uz tādas, kas ir par vienu vērtību augstāka un citas krāsas.',
    klondikeTutorialStep4: 'Tu vari pārvietot secību, ja tās apakšējā kārts ir par vienu vērtību zemāka un citas krāsas nekā tā, uz kuru to liec.',
    klondikeTutorialStep5: 'Ja uz galda ir tukša kolonna, tajā drīkst likt tikai karali vai secību, kas sākas ar karali.',
    klondikeTutorialStep6: 'Ja nav vairs gājienu, spied uz kavu, lai atklātu jaunas kārtis. Tās var likt uz galda vai pamata kaudzēm.',
    klondikeTutorialStep7: 'Lieliski! Tagad turpini spēlēt pats.',
    klondikeTutorialStep8: 'Ja kāršu kava beidzas, pieskaries tai, lai atsvaidzinātu un turpinātu spēli.',
    klondikeTutorialStep9: 'Tev gandrīz izdevās! Pabeidz visas pamata kaudzes un uzvari spēli.',

    spiderTutorialStep1: 'Tavs mērķis ir pārvietot visas kārtis uz pamata kaudzēm, veidojot dilstošas secības no karaļa līdz dūzim uz galda. Spied uz kārti, lai sāktu veidot secību!',
    spiderTutorialStep2: 'Tu vari pārvietot secību, ja tās apakšējā kārts ir par vienu vērtību zemāka nekā tā, uz kuru to liec. Spied uz tās, lai pārvietotu visu kaudzi!',
    spiderTutorialStep3: 'Lieliski! Turpini veidot secību — kad tā būs pabeigta, tā automātiski pāries uz pamata kaudzēm.',
    spiderTutorialStep4: 'Ja tev nav gājienu, spied uz kavas, lai izdalītu jaunas kārtis — pa vienai katrā kolonnā.',
    spiderTutorialStep5: 'Labi padarīts! Tagad turpini spēli pats un pabeidz to!',

    freeCellTutorialStep1: 'Tavs mērķis ir pārvietot visas kārtis uz pamata kaudzēm, katru mastu sakārtojot augošā secībā no dūža līdz kungam – piemēram, A♠, 2♠, 3♠ un tā tālāk. Spied uz kārti, lai to turp nosūtītu!',
    freeCellTutorialStep2: 'Labi padarīts! Tu vari pārvietot kārtis starp kolonnām – vienkārši noliec kārti uz tādas, kas ir vienu vērtību augstāka un citas krāsas.',
    freeCellTutorialStep3: 'Tu vari pārvietot secību, ja apakšējā kārts ir vienu vērtību zemāka un citas krāsas nekā kārts, uz kuras to liec. Atceries: nevari pārvietot vairāk kāršu nekā tukšo brīvo šūnu skaits plus viens.',
    freeCellTutorialStep4: 'Lieliski! Jebkuru vienu kārti vai secību vari novietot tukšā kolonnā uz galda.',
    freeCellTutorialStep5: 'Brīvās šūnas ir īpašas vietas, kur kārtis var uzglabāt īslaicīgi. Katrā var būt viena kārts, ko vēlāk vari pārvietot atpakaļ uz galdu vai pamata kaudzēm.',
    freeCellTutorialStep6: 'Tagad tava kārta! Izmanto to, ko esi iemācījies, un pabeidz spēli!',
    startTutorialPopupTitle: 'Laipni lūgts! Izmēģini īsu pamācību un apgūsti pamatus pirms sāc spēlēt.',
    startTutorial: 'Sākt pamācību',
    skipTutorial: 'Izlaist',
};
